import { Header } from '@/shared/Header';
import { SpinnerIcon } from '@/shared/components/icons/spinner.icon';
import { useTopProgress } from '@/shared/hooks/useTopProgress';
import { useCallback, useEffect, useRef, useState } from 'react';
import { Title } from '../../../Title';

interface PhoneNumberInputProps {
  phoneNumber: string;
  setPhoneNumber: (phoneNumber: string) => void;
  onSubmit: () => Promise<void>;
  onClickBackButton: () => void;
}

export const PhoneNumberInput = ({ phoneNumber, setPhoneNumber, onSubmit, onClickBackButton }: PhoneNumberInputProps) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const [isLoading, setIsLoading] = useState(false);
  useTopProgress(isLoading);

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  const handlePhoneNumberChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const value = e.target.value.replace(/[^\d]/g, '');
      if (value.length <= 11) {
        setPhoneNumber(value);
      }
    },
    [setPhoneNumber],
  );

  const handleSubmit = async () => {
    setIsLoading(true);
    try {
      await onSubmit();
    } catch {
      alert('エラーが発生しました');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      <Header onClickBackButton={onClickBackButton} headerClassName="border-b-[0px]" />

      <div className="flex flex-col">
        <div className="mt-[40px] mb-[72px]">
          <Title>
            電話番号を
            <br />
            入力してください
          </Title>
        </div>

        <div className="w-full">
          <input
            ref={inputRef}
            type="tel"
            value={phoneNumber}
            onChange={handlePhoneNumberChange}
            placeholder="08012345678"
            className="flex w-full py-2 border-b border-gray-200 focus:outline-none focus:border-gray-600 font-light rounded-none"
          />

          <div className="mt-[40px]">
            <button
              type="button"
              onClick={handleSubmit}
              disabled={phoneNumber.length < 11 || isLoading}
              className="flex w-full min-h-[56px] p-4 bg-gray-100 text-gray-400 font-semibold rounded-[2px] disabled:opacity-90 enabled:bg-primary enabled:text-white transition-colors justify-center items-center"
            >
              {isLoading ? <SpinnerIcon className="w-5 h-5" /> : '次へ進む'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
